import { MapPin, Phone, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS } from "@/data/business";
import { CITIES } from "@/data/cities";
import CountyMap from "@/components/site/CountyMap";
import { AppleDirections } from "@/components/site/AppleDirections";

export default function ServiceAreas() {
  const cities = CITIES.filter((c) => !c.isCounty);
  return (
    <section id="areas" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-red-600">
            Proudly Serving
          </p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900">
            Garage Door Repair Across Collin &amp; Denton County
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Based in Prosper and fully mobile, we provide fast same-day garage
            door repair across {cities.length}+ communities throughout Collin &amp;
            Denton County. Tap a pin on the map or pick your city below for local details.
          </p>
        </div>

        {/* Interactive county map */}
        <div className="mt-12">
          <CountyMap />
          <div className="mt-4 flex justify-center">
            <AppleDirections variant="outline" />
          </div>
        </div>

        {/* City pill cloud — labeled links for accessibility, mobile + SEO */}
        <div className="mt-8 flex flex-wrap gap-2.5" data-testid="areas-city-cloud">
          {cities.map((city) => (
            <Link
              key={city.slug}
              to={`/garage-door-repair/${city.slug}`}
              className="group inline-flex items-center gap-1.5 bg-slate-50 border border-slate-200 rounded-sm px-3.5 py-2 text-sm font-bold text-slate-800 hover:border-red-600 hover:text-red-700 transition-colors"
              data-testid={`area-${city.slug}`}
            >
              <MapPin className="h-3.5 w-3.5 text-red-600 shrink-0" />
              {city.name}
              <ArrowRight className="h-3 w-3 opacity-0 -ml-1 group-hover:opacity-100 group-hover:ml-0 transition-all" />
            </Link>
          ))}
        </div>

        <a
          href={`tel:${BUSINESS.phoneRaw}`}
          className="mt-10 inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold px-6 py-3.5 rounded-sm transition-colors"
          data-testid="areas-call-button"
        >
          <Phone className="h-4 w-4" /> Check Availability in Your Area
        </a>
      </div>
    </section>
  );
}
